import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import Popup from "@my-dld/components/Popup/Popup";
import { JQModal } from "@my-dld/components/Popup/Utils";
import Dropzone from "react-dropzone";
import ReactCrop, { Crop } from "react-image-crop";
import { ProfilePicUpdate } from "@10x/dubai-rest-api/dist/profilepic/entity";
import { ProfilePicApi, ProfilePicEntity } from "@10x/dubai-rest-api";
import { getParticipantID } from "@10x/sso";
import { showErrorMessage } from "@my-dld/utils/UIUtils";
import { trackEvent, trackEventWithData } from "@my-dld/utils/Analytics";
import { SSOProfile } from "@10x/sso/SSOProfile";
import { exToMessage, profile } from "@eres/ssoapi/api";

interface Props {

	onDismiss?: () => void;
}

interface State {
	step: "select" | "edit" | "preview";
	picData?: string;
	cropedData?: string;
	crop: Crop;
	isLoading?: boolean;
}

const defaultCrop: Crop = {
	aspect: 1,
	unit: "px",
	width: 50,
	height: 50,
	x: 25,
	y: 25
};

class PicPopup extends Component<Props, State> {
	imageView?: HTMLImageElement;

	constructor( props: Props ) {
		super( props );
		this.state = {
			step: "select",
			crop: defaultCrop,
		};
	}

	render() {
		const { step, crop, cropedData, isLoading } = this.state;
		return (
			<Popup
				id={ "pic-update" } showCloseButton={ false } onDismiss={ this.props.onDismiss }
				title={ Strings.update_photo } showIcon={ false }>
				<div className="pic-uploader">
					{ step == "select" &&
						<div className="text-center">
							<div id="file-drop-zone">
								<Dropzone
									maxSize={ 2097152 }
									onDropRejected={ this.handleFileReject }
									onDrop={ this.handleFileDrop }
									accept={ [ "image/png", "image/jpeg" ] }>
									{ ( { getRootProps, getInputProps } ) => (
										<section className={ "pic-edit-drop-zone-wrapper" }  { ...getRootProps() }>
											<div className={ "pic-edit-drop-zone" }>
												<input { ...getInputProps() } />
												<span>{ Strings.pic_file_picker_help }</span>
											</div>
										</section>
									) }
								</Dropzone>
							</div>
						</div>
					}
					{ step == "edit" &&
						<div id="profile-pic-edit-zone" className={ "profile-pic-edit-zone" }>
							<ReactCrop
								onImageLoaded={ this.onImageLoaded }
								circularCrop={ true }
								src={ this.state.picData! } crop={ crop } onChange={ newCrop => {
								this.setState( {
									crop: newCrop
								} );
							} }/>
                        <div className={"modal-footer justify-content-center"}>
                            <button
                                className={"btn btn_1 me-2"} onClick={() => {
                                    this.setState({ step: "preview", cropedData: getCroppedImg(this.imageView!, crop) });
                                }
                                }>{Strings.continue}</button>
								<button
                                className={ "btn btn-grey " } onClick={ () => {
									this.setState( { step: "select" } );
								}
								}>{ Strings.back }</button>
							</div>
						</div>
					}
					{ step == "preview" &&
						<div className={ "profile-pic-preview-zone" }>
							<div className="profile-img-link text-center mb-3">
								<img
									width={ 150 }
									height={ 150 }
									sizes={ "100" }
									src={ cropedData }
								/>
							</div>
							<div className={ "profile-pic-edit-btn-container modal-footer justify-content-between" }>
								<button
									className={ "btn-grey btn-sm btn-edit-pic-back" } onClick={ () => {
									this.setState( { step: "edit", isLoading: false } );
								}
								}>{ Strings.back }</button>
								<button className={ "btn_1 btn-sm btn-edit-pic-next" } onClick={ this.onImageConfirmed }>
									{ ( isLoading ) ? <div className="relative spinner-border " role="status">
										<span className="sr-only">Loading...</span>
									</div> : Strings.confirm }
								</button>
							</div>
						</div>
					}
				</div>
			</Popup>
		);
	}

	dispatchUpdate = () => {
		trackEvent( "Profile", "PicUpdated" );
		JQModal( "pic-update" ).hide();
		document.dispatchEvent( new Event( "profile_image_updated" ) );
	};
	uploadTabuPic = () => {
		let participantID = getParticipantID();
		if ( !participantID ) {
			showErrorMessage( "PicUpdateFailed" );
			return;
		}
		this.setState( { isLoading: true } );
		const r: ProfilePicUpdate = {
			photo: this.state.cropedData!.replace( /^data:(.*;base64,)?/, "" )
		};
		trackEvent( "Profile", "TryPicUpdate" );
		ProfilePicApi.updateProfilePic( participantID!, r )
		.then( ProfilePicEntity.validateResponse )
		.then( this.dispatchUpdate )
		.catch( e => {
			this.setState( { isLoading: false } );
			trackEventWithData( "Profile", "PicUpdateFailed", { reason: e.toString() } );
			showErrorMessage( e.toString() );
		} );
	};
	uploadSSOPic = () => {
		this.setState( { isLoading: true } );
		const photo = this.state.cropedData!;
		trackEvent( "Profile", "TryPicUpdate" );
		profile.updateAvatar( photo )
		.then( this.dispatchUpdate )
		.catch( e => {
			this.setState( { isLoading: false } );
			return exToMessage( e ).then( msg => {
				trackEventWithData( "Profile", "PicUpdateFailed", { reason: msg.error } );
				showErrorMessage( msg.error );
			} );
		} );
	};
	onImageConfirmed = () => {
		if ( this.state.isLoading ) return;
		if ( SSOProfile.getProfile() ) {
			this.uploadSSOPic();
		} else {
			this.uploadTabuPic();
		}
	};
	onImageLoaded = ( image: HTMLImageElement ) => {
		this.imageView = image;
		const s = image.width > image.height ? image.height : image.width;
		const width = s;
		const height = s;
		const x = ( image.width - s ) / 2;
		const y = ( image.height - s ) / 2;
		this.setState( {
			crop: {
				unit: "px",
				aspect: 1,
				width,
				height,
				x,
				y,
			},
		} );
		return false;
	};

	handleFileReject = ( files: File[] ) => {
		console.log( "drop rejected" );
	};
	handleFileDrop = ( files: File[] ) => {
		if ( files && files.length > 0 ) {
			const reader = new FileReader();
			reader.onload = () => {
				const binaryStr = reader.result as string;
				this.setState( {
					picData: binaryStr,
					step: "edit",
					crop: defaultCrop,
				} );
			};
			reader.readAsDataURL( files[ 0 ] );
		}
	};

	componentDidMount(): void {
		JQModal( "pic-update" ).show();
	}

}

function getCroppedImg( image: HTMLImageElement, crop: Crop ) {
	const canvas = document.createElement( "canvas" );
	const scaleX = image.naturalWidth / image.width;
	const scaleY = image.naturalHeight / image.height;
	canvas.width = crop.width!;
	canvas.height = crop.height!;
	const ctx = canvas.getContext( "2d" )!;

	ctx.drawImage(
		image,
		crop.x! * scaleX,
		crop.y! * scaleY,
		crop.width! * scaleX,
		crop.height! * scaleY,
		0,
		0,
		crop.width!,
		crop.height!,
	);

	const base64Image = canvas.toDataURL( "image/jpeg" );
	return base64Image;
}

export default PicPopup;
